import React from "react";
// import CloneChildren from "@components/children";
import { connect, useSelector } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import {
  Container,
  AddressContainer,
  Row,
  AddressTitle,
  EditButton,
  FullAddress,
  Title,
  FormContainer
} from "./styles";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const Address = ({ actions }: any) => {
  const { mainText, secondaryText } = useSelector(
    ({ globalState }: any) => {
      return {
        mainText: globalState?.payloadData?.address?.mainText,
        secondaryText: globalState?.payloadData?.address?.secondaryText
      }
    }
  );

  const onClickHandler = () => {
    actions?.on_edit_click.forEach((func: any) => {
      func.funCall?.(func.args);
    });
  };

  return (
    <AddressContainer>
      <Row>
        <AddressTitle>{mainText}</AddressTitle>
        <EditButton onClick={onClickHandler}>Edit</EditButton>
      </Row>
      <FullAddress>{secondaryText}</FullAddress>
    </AddressContainer>
  );
};

const AddressForm = (props: any) => {
  const { is_visible, children, actions } = props;

  if (!is_visible) return <></>;

  return (
    <Container>
      <Address actions={{ ...actions }} />
      <Title>Add complete address</Title>
      <FormContainer>
          {/* <CloneChildren
            styles={{
              display: "flex",
              "flex-direction": "column",
              justifyContent: "center",
              gap: "32px"
            }}
            children={children}
            props={props}
          /> */}
          {children}
      </FormContainer>
    </Container>
  );
};

export default connect(mapStateToProps)(AddressForm);
